import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Brasao } from "../../components/Layout";
import { entrarComoCandidato, fmt } from "../../lib/api";

/**
 * Entrada da área do candidato. Login por um POST comum (JSON no corpo,
 * {@code entrarComoCandidato}), que cria a sessão no servidor; as
 * requisições seguintes seguem pelo cookie.
 */
export function LoginCandidato() {
  const [cpf, setCpf] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);
  const navigate = useNavigate();

  async function enviar(ev: FormEvent) {
    ev.preventDefault();
    setEntrando(true);
    setErro(null);
    try {
      await entrarComoCandidato(cpf.replace(/\D/g, ""), senha);
      navigate("/area");
    } catch {
      setErro("CPF ou senha incorretos.");
      setSenha("");
    } finally {
      setEntrando(false);
    }
  }

  return (
    <div className="tema-candidato tc-entrada">
      <div className="tc-entrada-corpo">
        <div className="tc-entrada-caixa">
          <div className="linha" style={{ justifyContent: "center", marginBottom: 8 }}>
            <Brasao tamanho={32} />
          </div>

          <form onSubmit={enviar} className="tc-cartao" noValidate>
            <h1 className="tc-titulo">Entrar</h1>

            {erro && <div className="tc-erro" role="alert">{erro}</div>}

            <div className="tc-campo">
              <label htmlFor="cpf">CPF</label>
              <input id="cpf" value={cpf} inputMode="numeric" required autoComplete="username"
                     onChange={(e) => setCpf(fmt.cpf(e.target.value))} />
            </div>

            <div className="tc-campo">
              <label htmlFor="senha">Senha</label>
              <input id="senha" type="password" value={senha} required
                     autoComplete="current-password" onChange={(e) => setSenha(e.target.value)} />
            </div>

            <button type="submit" className="tc-btn tc-btn-primario tc-btn-largo" disabled={entrando}>
              {entrando ? "Entrando..." : "Entrar"}
            </button>
          </form>

          <div className="tc-links">
            <Link to="/primeiro-acesso">Já se inscreveu antes mas nunca criou senha?</Link>
            <Link to="/esqueci-senha">Esqueci minha senha</Link>
            <Link to="/inscricao">Ainda não tenho cadastro</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
